// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"57161500","787":"7dba3df5"}[chunkId] + ".chunk.js";
};